<template>
    <div class="container">
        <DataAtual/>
        <b-breadcrumb :items="this.$route.meta.breadcrumb"></b-breadcrumb>
        <b-card 
            class="p-1 mb-3 bg-white rounded"
            footer-bg-variant="transparent">  
            <alert
                :variant="alert.variant"            
                dismissible
                :mensagens="alert.mensagens"
                :value="alert.exibir"
                @input="alertDismissed">
            </alert>
            <b-row >
                <b-col>    
                    <div v-html="content"></div>                        
                </b-col>
            </b-row>
            <template v-slot:footer >                                  
                <b-row >  
                    <b-col class="text-left">   
                        <b-button
                            size="sm" 
                            variant="outline-secondary"                                 
                            @click.prevent="$router.go(-1)"
                        >
                            <i class="fa fa-arrow-left pr-1" ></i> Voltar
                        </b-button>          
                    </b-col>                           
                </b-row>
            </template>  
        </b-card>
    </div>
</template>

<script>

import Alert from '../../models/Alert'
import DataAtual from '../../components/DataAtual';

export default {

    components: {
        DataAtual
    },

    data(){
        return {                                                
            content: null,
            alert: new Alert(),
        }
    },

    methods: {
        
        alertDismissed(){           
            this.alert = new Alert();
        },

        listar() {
            this.$api.expediente.listar()
            .then(response => {                                            
                if(response.data.success){                                                    
                    if(response.data.data && response.data.data.length != 0){
                        this.content = response.data.data.conteudo;                                                     
                    }                                                                             
                }
            })
            .catch(error => {
                this.$helper.showAlert(this.alert, 
                                       this.$constantes.alert.variants.DANGER,
                                       error.response.data.errors);                                
            });
        },

    },
    
    mounted(){ 
        this.listar();          
    },    
}

</script>

<style scoped>

    .breadcrumb{
        font-size: 0.9em;
    } 

</style>
